<template>
  <div>
    <div class="pag-wrap mail selected">
      <div class="bread-crumbs">
        <a
          href="//www.ciftis.org"
          clstag="appH5|keycount|exhibitorList|to-HomePage"
          >{{ $t('首页') }}</a
        ><i></i><span>{{ $t('展会服务') }}</span
        ><i></i><span>{{ $t('知识产权保护') }}</span>
      </div>
      <h1>知识产权保护</h1>
      <div class="content selected">
        <div class="rule-box">
          <TextRule></TextRule>
        </div>
        <div class="upload-box">
          <el-alert
            title="仅企业用户"
            type="warning"
            show-icon
            :closable="false"
          ></el-alert>
          <div class="tips">
            <!-- <span>请上传</span> -->
            <!-- <a
              href="https://www.ciftis.org/cn/attachDir/2020/08/2020080518303827871.docx"
              >《参展知识产权承诺书》</a
            ><br /> -->
            <!-- <a
              href="https://www.ciftis.org//cn/attachDir/2020/08/2020080518331583990.docx"
              >《展会知识产权投诉书》</a
            ><br />
            <span>和左侧处理程序中要求的投诉材料</span> -->
            <span>请上传左侧投诉须知里要求的材料</span>
          </div>
          <div class="upload">
            <h3>上传附件</h3>
            <el-upload
              class="upload-demo"
              ref="upload"
              :headers="headers"
              action="/newscenter-api/v1/complaint/uploadFile"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :auto-upload="false"
              :file-list="fileList"
              :limit="1"
              multiple
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <!-- <div class="el-upload__tip" slot="tip">
                <ul>
                  <li>附件要求：</li>
                  <li>仅限一个文件，大小：10M以内</li>
                  <li>格式：txt,docx,doc,xls,xlsx,pdf,jpg,png,jpeg,zip,rar</li>
                </ul>
              </div> -->
            </el-upload>
            <div class="upload-tip">
              <ul>
                <li>附件要求：</li>
                <li>仅限一个文件，10M以内</li>
                <li>格式：docx,doc,xls,xlsx,pdf,jpg,png,jpeg,zip,rar</li>
              </ul>
            </div>
          </div>
          <el-button
            size="small"
            type="primary"
            @click="submit"
            style="width:100%"
            :disabled="btnDisabled"
            >{{ sendButton }}</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      size="small"
      :title="$t('提交投诉')"
      :close-on-click-modal="false"
      @close="close"
      width="456px"
    >
      <div class="uploadInfo">
        <i class="el-icon-success"></i>
        <h3>提交投诉成功</h3>
        <p>
          工作人员将会核实信息，并通过用户提供的联系方式进行进一步沟通，您也可以直接前往国家会议中心三层知识产权保护办公室进行线下投诉
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Cookie from 'js-cookie'
import TextRule from '@/views/mail/components/Text'
import { getAccount } from '@/api/registry-api'
export default {
  props: {},
  components: {
    TextRule
  },
  mixins: [],
  data() {
    return {
      headers: {
        cookie: document.cookie,
        'x-csrf-token': Cookie.get('csrfToken')
      },
      fileList: [],
      fileType: [
        'docx',
        'doc',
        'xls',
        'xlsx',
        'pdf',
        'jpg',
        'png',
        'jpeg',
        'zip',
        'rar'
      ],
      dialogVisible: false,
      sendButton: '发送投诉',
      btnDisabled: false
    }
  },
  watch: {},
  computed: {},
  async mounted() {
    document.title = '线上投诉通道'
    this.login()
  },
  created() {},
  filters: {},
  methods: {
    async login() {
      const { data } = await getAccount()
      if (data.tenantType !== 'COMPANY') {
        try {
          await this.$confirm('仅企业用户可提交侵权投诉！', '提示', {
            confirmButtonText: '切换用户',
            showCancelButton: false
          })
        } catch (err) {
          console.log(err)
        } finally {
          window.location.href = process.env.VUE_APP_LOGIN + '/login/company'
          return Promise.reject(false) // eslint-disable-line
        }
      } else {
        return Promise.resolve(true)
      }
    },
    async submit() {
      this.btnDisabled = true
      this.sendButton = '发送中...'
      try {
        await this.login()
        if (!this.fileList.length) {
          this.$message.error('请上传附件')
          this.sendButton = '发送投诉'
          this.btnDisabled = false
        }
      } catch (err) {
        this.sendButton = '发送投诉'
        this.btnDisabled = false
        console.log(err)
      }
      this.$refs.upload.submit()
    },
    handleRemove(file) {
      let fileIndex = this.fileList.findIndex(val => {
        return val.uid === file.uid
      })
      if (fileIndex !== -1) {
        this.fileList.splice(fileIndex, 1)
      }
      // let sucIndex = this.successList.findIndex(val => {
      //   return val.uid === file.uid
      // })
      // if (sucIndex !== -1) {
      //   this.successList.splice(sucIndex, 1)
      // }
    },
    handleChange(file) {
      let booleanType =
        file.name.indexOf('.') !== -1 &&
        this.fileType.includes(
          file.name.split('.')[file.name.split('.').length - 1]
        )
      let booleanSize = file.size / 1024 / 1024 < 10
      if (booleanSize && booleanType) {
        let index = this.fileList.findIndex(val => file.uid === val.uid)
        if (index === -1) {
          this.fileList.push(file)
        }
      } else {
        if (!booleanType) {
          this.$message.error('暂不支持该类型的文件')
        } else if (!booleanSize) {
          this.$message.error('文件最大为10M')
        }
        let index = this.$refs.upload.uploadFiles.findIndex(
          val => file.uid === val.uid
        )
        if (index !== -1) {
          this.$refs.upload.uploadFiles.splice(index, 1)
        }
      }
    },
    uploadSuccess(res) {
      if (res.result.data) {
        this.dialogVisible = true
      } else {
        this.sendButton = '发送投诉'
        this.btnDisabled = false
        this.$message.error('发送失败，请重试')
      }
    },
    uploadError(res) {
      let error
      try {
        error = JSON.parse(res.message)
      } catch (err) {
        error = {}
      }
      this.$message.error(error.error.message || '发送失败，请重试')
      this.sendButton = '发送投诉'
      this.btnDisabled = false
      this.fileList.splice(0, 1)
      this.$refs.upload.uploadFiles(0, 1)
    },
    close() {
      window.close()
    }
  }
}
</script>
<style>
.el-dialog__footer {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.mail {
  h1 {
    position: relative;
    height: 68px;
    margin: 0 0 40px;
    color: #373737;
    font-size: 34px;
    line-height: 48px;
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 62px;
      width: 30px;
      height: 6px;
      background: #fe8c01;
    }
  }
  .content {
    display: flex;
    margin: 0 0 30px;

    .rule-box {
      width: 774px;
      margin: 0 40px 0 0;
      padding: 30px;
      border: 1px solid #d9e1e1;
      border-radius: 4px;
      background: #fff;
    }
    .upload-box {
      width: 388px;
      padding: 30px;
      border: 1px solid #d9e1e1;
      border-radius: 4px;
      background: #fff;

      .tips {
        margin: 24px 0;
        padding: 0 10px;
        border-left: 2px solid #fe8c01;
        color: #333;
        font-size: 16px;
        font-weight: bold;
        line-height: 28px;

        a {
          color: #fe8c01;
        }
      }
      .upload {
        padding: 20px 0 0;
        border-top: 1px solid #eee;

        h3 {
          font-weight: bold;
          color: #333;
          font-size: 16px;
          margin: 0 0 15px;
        }
      }
    }
  }
}
.uploadInfo {
  text-align: center;

  i {
    display: inline-block;
    width: 48px;
    height: 48px;
    margin: 0 0 30px;
    color: #26a872;
    font-size: 48px;
  }
  h3 {
    margin: 0 0 20px;
    color: #333;
    font-size: 20px;
    font-weight: bold;
  }
  p {
    color: #999;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
    padding: 0 27px;
  }
}
.upload-tip {
  padding: 20px 10px;
  line-height: 150%;
  background: #f7f7f7;
  color: #999999;
  margin: 20px 0px;
}
</style>
